import clsx from 'clsx';

import styles from './styles.module.scss';
import { CircularProgress } from '@mui/material';

type IProps = { className?: string };

function Loader({ className }: IProps) {
  return (
    <div className={clsx(styles.root, className)}>
      <CircularProgress color={'primary'} size={80} />
    </div>
  );
}

export default Loader;
